import React, {useRef, useState} from 'react';
import {SelectInput, Title} from "react-admin";
import CardContent from "@material-ui/core/CardContent";
import {downloadFile, ReportForm, schoolYears} from "../../components";
import Grid from "@material-ui/core/Grid";
import moment from "moment/moment";
import env from "../../env";

const ProductExemptionReport = () => {
    const ref = useRef({
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        schoolYear: schoolYears[0]?.id
    })

    const [loading, setLoading] = useState(false)
    const excelReport = () => {
        const {schoolYear} = ref.current
        setLoading(true)
        downloadFile(`${env.baseURL}/reports/product-exemption?schoolYearId=${schoolYear}`, 'bao_cao_mien_giam.xlsx')
            .finally(() => {
                setLoading(false)
            })
    }

    return <div>
        <Title title="resources.product-exemption-report.name"/>
        <CardContent>
            <ReportForm params={ref.current}
                        excelReport={excelReport}
                        isLoading={loading}
            >
                <Grid container spacing={8}>
                    <Grid item xs={12} sm={6}>
                        <SelectInput label="resources.schoolYears.name" source="schoolYear" choices={schoolYears}/>
                    </Grid>
                </Grid>
            </ReportForm>
        </CardContent>
    </div>
}

export default ProductExemptionReport;
